(function () {
    var manageArticleSelect = {
        $removeUsersBtn: $('.js__removeUsers'),
        // embo customization
        $removeUserForm: $('.manage-article-select__removeUserForm'),
        $confirmationModal: $('#confirmRemoveUser'),
        selectAllCheckbox: '[name="markallInPage"]',
        $body: $('body'),

        init: function () {
            $(window).on('load', function (e) {
                if (window.location.hash === '#PERMISSIONS') $('[title="PERMISSIONS"]').click();
            });

            manageArticleSelect.controller();
            manageArticleSelect.addtionalController();
        },
        // embo customization
        addtionalController: function () {
            $body.on('click', '.manage-article-select__removeUser', function (e) {
                e.preventDefault();
                manageArticleSelect.$removeUserForm.submit();
            });
        },
        controller: function () {
            manageArticleSelect.$removeUsersBtn.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                manageArticleSelect.form.submit();
            });

            manageArticleSelect.$body.on('click', manageArticleSelect.selectAllCheckbox, function (e) {
                var $targetrows = $(this).closest('.selectMenuLabel').find('~.table-responsive tr:visible');
                var checkboxes = $targetrows.find('[type="checkbox"]');
                checkboxes.prop('checked', $(this).prop('checked'));
            });

            $(document).ready(function () {
                if ($('.manage-article-select').find('.infoBox').length) {
                    $('.addUserPermissionTab a').trigger('click');
                }
            });
        },
        clearSelectAll: function () {
            var $selectAllchk = $(manageArticleSelect.selectAllCheckbox),
                $targetrows = null,
                checkboxes = null;

            if ($selectAllchk.is(':checked')) {
                $selectAllchk.prop('checked', false);
                $targetrows = $selectAllchk.closest('.selectMenuLabel').find('~.table-responsive tr');
                checkboxes = $targetrows.find('[type="checkbox"]');
                checkboxes.prop('checked', false);
            }
        },
        form: {
            // embo customization
            submit: function () {
                var hasUserChecked = manageArticleSelect.form.conflictCheck(),
                    usrName = null,
                    name = null;
                if (!hasUserChecked) {
                    manageArticleSelect.form.error_msg();
                    return;
                } else {
                    usrName = [];

                    manageArticleSelect.$confirmationModal.find('.usersName').html(usrName);

                    manageArticleSelect.$removeUserForm
                        .find('[type="checkbox"][name!="markallInPage"]:checked')
                        .each(function () {
                            name = $(this).closest('tr').find('td:last-child').html();
                            usrName.push(name);
                        });

                    for (let i in usrName) {
                        if (i < usrName.length - 1)
                            manageArticleSelect.$confirmationModal.find('.usersName').append(usrName[i] + ', ');
                        else manageArticleSelect.$confirmationModal.find('.usersName').append(usrName[i]);
                    }

                    manageArticleSelect.$confirmationModal.modal('show');
                }
            },
            conflictCheck: function () {
                return (
                    manageArticleSelect.$removeUsersBtn.closest('form').find('[type="checkbox"]:checked').length !== 0
                );
            },
            error_msg: function () {
                alert('Please select at least one user.');
            },
        },
    };

    UX.manageArticleSelect = manageArticleSelect; // add to global namespace
})();
